module.exports = new __parcel__URL__("meeting-notes.45a2e0c0.svg").toString();